import React from "react";

const Help: React.FC = () => {
  return (
    <div>
      <p>
        This page shows the draft overview with file preview and draft details.
      </p>
    </div>
  );
};

export default Help;
